import { render, staticRenderFns } from "./inserts.vue?vue&type=template&id=98392a16&scoped=true&"
import script from "./inserts.vue?vue&type=script&lang=js&"
export * from "./inserts.vue?vue&type=script&lang=js&"
import style0 from "./inserts.vue?vue&type=style&index=0&id=98392a16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98392a16",
  null
  
)

export default component.exports